import React from 'react';

const MyAccountPage = () => {
    return (
        <section 
            id="globalContent" 
            className="global-content my-account-page">

            <div className="site-wrapper page-content-wrapper">
                <h1>My Account</h1> 
            </div>
        </section>
    );
};

export default MyAccountPage;